import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { STAGE_LABELS, STAGES } from "../lib/constants";

const CATS = [
  ["commerciali", "Lead in pipeline", "Trattative attive: con telefono o email, esclusi Free, Rete, archiviati e parcheggiati", "#FDD003"],
  ["free", "Contatti Free", "Configuratore e strumenti gratuiti", "#38bdf8"],
  ["rete", "Area Rete", "Lead gestiti dalla rete partner", "#10b981"],
  ["archiviati", "Archiviati / persi", "Spostati nel cimitero", "#9ca3af"],
  ["parcheggio", "In parcheggio", "Messi in pausa (automazioni di riattivazione)", "#a855f7"],
  ["senza_contatti", "Senza contatti", "Nessun telefono né email", "#ef4444"],
];

// Popup "Lead totali": scomposizione per categoria (mutuamente esclusive) + fasi dei lead commerciali.
export default function LeadTotalsDialog({ open, onOpenChange, stats }) {
  const c = stats?.categories || {};
  const tot = stats?.total || 0;
  const st = stats?.commerciali_by_stage || {};
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="lead-totals-dialog">
        <DialogHeader>
          <DialogTitle>Lead totali: {tot}</DialogTitle>
          <DialogDescription>Tutti i lead presenti nel CRM, suddivisi per categoria (ogni lead conta in una sola categoria).</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {CATS.map(([k, label, desc, col]) => {
            const n = c[k] || 0, pct = tot ? Math.round((100 * n) / tot) : 0;
            return (
              <div key={k} data-testid={`lead-cat-${k}`}>
                <div className="flex items-baseline justify-between text-sm">
                  <span className="font-semibold">{label}</span>
                  <span className="font-heading font-bold" data-testid={`lead-cat-${k}-count`}>{n} <span className="text-xs text-muted-foreground font-normal">({pct}%)</span></span>
                </div>
                <div className="h-1.5 rounded bg-muted mt-1 overflow-hidden"><div className="h-full rounded" style={{ width: `${pct}%`, background: col }} /></div>
                <div className="text-[11px] text-muted-foreground mt-0.5">{desc}</div>
              </div>
            );
          })}
        </div>
        <div className="border-t border-border pt-3">
          <div className="text-xs uppercase tracking-widest text-muted-foreground font-bold mb-2">Lead in pipeline per fase</div>
          <div className="grid grid-cols-2 gap-x-6 gap-y-1 text-sm">
            {STAGES.map((s) => (
              <div key={s} className="flex justify-between" data-testid={`lead-comm-stage-${s}`}>
                <span className="text-muted-foreground">{STAGE_LABELS[s] || s}</span><span className="font-semibold">{st[s] || 0}</span>
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
